import '../Styles.css';
import { jwtDecode } from "jwt-decode";
import { Middleware, MiddlewareProvider } from './Middleware';
import axios from 'axios';
import React from 'react';
import { TokenValidateExpiration } from './Token';

const token = localStorage.getItem("token");
var decode = "";
var rfc = "";
var user = "";

if (token) {
    decode = jwtDecode(token);
    rfc = decode.rfc;
    user = rfc;
}

function ProviderGeneralDataSave() {
    document.getElementById("Chg").style.display = "block";
    document.getElementById("Btn").style.display = "none";
    document.getElementById("messageError").innerHTML = "";
    
    axios.post(process.env.REACT_APP_API_PORTAL_PROVEEDORES+'/api/provider/general-data/save/'+token, {  
        IdUser: decode.id,
        TipoProveedor: document.getElementById("TipoProveedor").value,              
        RegistroREPSE: document.getElementById("RegistroREPSE").value,
        CategoriaAbastoSuministro: document.getElementById("CategoriaAbastoSuministro").value,
        SubCategoriaAbastoSuministro: document.getElementById("SubcategoriaAbastoSuministro").value,
        }, {
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        }
    ).then(response => {
        window.location.href = '/proveedor-contactos';
    })
    .catch(error => {
        window.scrollTo(0, 0);
        document.getElementById("Chg").style.display = "none";
        document.getElementById("Btn").style.display = "inline-block";
        document.getElementById("messageError").innerHTML = error.response.data.error;
    });
}

function ProviderGeneralData() {
    Middleware();
    MiddlewareProvider();

    const token = localStorage.getItem("token");
    TokenValidateExpiration(token);

    const [data, setData] = React.useState([]);
    const [regimenCapital, setRegimenCapital] = React.useState([]);
    const [contribuyente, setContribuyente] = React.useState([]);
    const [regimenFiscal, setRegimenFiscal] = React.useState([]);
    const [actividadEconomica, setActividadEconomica] = React.useState([]);
    const [proveedor, setProveedor] = React.useState([]);
    const [tipoProveedor, setTipoProveedor] = React.useState([]);
    const [categoriaAbastoSuministro, setCategoriaAbastoSuministro] = React.useState([]);
    const [subcategoriaAbastoSuministro, setSubcategoriaAbastoSuministro] = React.useState([]);

    React.useEffect(() => {
        axios.get(process.env.REACT_APP_API_PORTAL_PROVEEDORES+'/api/provider/general-data/get/'+decode.id+'/'+token, {}, {
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        }
    )
    .then(response => {
        console.log(response);
        setData(response.data.GeneralData[0]);
        setRegimenCapital(response.data.RegimenCapital);
        setContribuyente(response.data.Contribuyente);
        setRegimenFiscal(response.data.RegimenFiscal);
        setActividadEconomica(response.data.ActividadEconomica);
        setProveedor(response.data.Proveedor);
        setTipoProveedor(response.data.GeneralData[0].TipoProveedor);
        setCategoriaAbastoSuministro(response.data.CategoriaAbastoSuministro);
        setSubcategoriaAbastoSuministro(response.data.SubcategoriaAbastoSuministro);
    });
    }, []);

    setTimeout(() => {
            data.RegistroREPSE != ""
            ?
            (document.getElementById("RegistroREPSE").value = data.RegistroREPSE)
            :
            (document.getElementById("RegistroREPSE").value = "99999")
        }, 1000);

    return (
        <div className='Container'>
            <div className='Navbar'>
                <div>
                    <h5 className='text-white'>Portal de proveedores</h5>
                </div>
            </div>
            <div className='Section'>
                <div className='Header'>
                    <div className="text-center">
                        <div className='row'>
                            <div className='col-md-6 Text-left'>
                                <label className='mt-1 Text-Gray'><b>Usuario: </b>
                                    {  
                                        user
                                    }
                                </label>
                            </div>
                            <div className='col-md-6 Text-right'>
                                <a href='/logout'>
                                    <label>
                                        Cerrar sesión
                                        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fillRule="currentColor" className="bi bi-box-arrow-right m-1" viewBox="0 0 16 16">
                                            <path fillRule="evenodd" d="M10 12.5a.5.5 0 0 1-.5.5h-8a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 .5.5v2a.5.5 0 0 0 1 0v-2A1.5 1.5 0 0 0 9.5 2h-8A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h8a1.5 1.5 0 0 0 1.5-1.5v-2a.5.5 0 0 0-1 0z" />
                                            <path fillRule="evenodd" d="M15.854 8.354a.5.5 0 0 0 0-.708l-3-3a.5.5 0 0 0-.708.708L14.293 7.5H5.5a.5.5 0 0 0 0 1h8.793l-2.147 2.146a.5.5 0 0 0 .708.708z" />
                                        </svg>
                                    </label>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='Article'>
                    <div className="text-center">
                        <h1 className='Text-Red'>Datos generales</h1>
                        <br></br>
                        <label className='text-gray'>
                            Parte de tu información ha sido cargada previamente, por favor completa los campos restantes, considera los campos con asterisco (*) como obligatorios.
                        </label>
                        <br></br>
                        <br></br>
                        <br></br>
                        <form action={ProviderGeneralDataSave}>
                            <p id="messageError" className='Text-Red'></p>
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-lg-4 col-md-6">
                                        <div>
                                            <label>Registro Federal de Contribuyentes</label>
                                            <br></br>
                                            <input type="input" name="rfc" id="rfc" className="form-control Input-Style" value={rfc} disabled></input>
                                        </div>
                                    </div>
                                    <div className="col-lg-8 col-md-6">
                                        <div>
                                            <label>Denominación/Razón Social</label>
                                            <br></br>
                                            <input type="input" name="RazonSocial" id="RazonSocial" className="form-control Input-Style" value={data.RazonSocial} disabled></input>
                                        </div>
                                    </div>
                                </div>
                                <br></br>
                                <br></br>
                                <div className="row">
                                    <div className="col-lg-4 col-md-6">
                                        <div>
                                            <label>Régimen Capital</label>
                                            <select name="RegimenCapital" id="RegimenCapital" aria-label="Default select example" className="form-select Input-Style" value={data.RegimenCapital} disabled>
                                                {
                                                    regimenCapital.map(item => (
                                                        <option value={item.Codigo}>{item.Nombre}</option>
                                                    ))
                                                } 
                                            </select>
                                            <br></br>
                                            
                                        </div>
                                    </div>
                                    <div className="col-lg-8 col-md-6">
                                        <div>
                                            <label>Nombre Comercial</label>
                                            <br></br>
                                            <input type="input" name="NombreComercial" id="NombreComercial" className="form-control Input-Style" value={data.NombreComercial} disabled></input>
                                        </div>
                                    </div>
                                </div>
                                <br></br>
                                <br></br>
                                <div className="row">
                                    <div className="col-lg-4">
                                        <div>
                                            <label>Tipo de Contribuyente</label>
                                            <br></br>
                                            <select name="TipoContribuyente" id="TipoContribuyente" aria-label="Default select example" className="form-select Input-Style" value={data.TipoContribuyente} disabled>
                                                {
                                                    contribuyente.map(item => (
                                                        <option value={item.Codigo}>{item.Nombre}</option>
                                                    ))
                                                } 
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col">
                                        <div>
                                            <label>Régimen Fiscal</label>
                                            <br></br>
                                            <select name="RegimenFiscal" id="RegimenFiscal" aria-label="Default select example" className="form-select Input-Style" value={data.RegimenFiscal} disabled>
                                                {
                                                    regimenFiscal.map(item => (
                                                        <option value={item.Codigo}>{item.Nombre}</option>
                                                    ))
                                                } 
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col">
                                        <div>
                                            <label>Actividad Económica</label>
                                            <br></br>
                                            <select name="ActividadEconomica" id="ActividadEconomica" aria-label="Default select example" className="form-select Input-Style" value={data.ActividadEconomica} disabled>
                                                {
                                                    actividadEconomica.map(item => (
                                                        <option value={item.Codigo}>{item.Nombre}</option>
                                                    ))
                                                } 
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <br></br>
                                <br></br>
                                <div className="row">
                                    <div className="col-lg-12">
                                        <div>
                                            <label>Régimen</label>
                                            <br></br>
                                            <input type="input" name="Regimen" id="Regimen" className="form-control Input-Style" value={data.Regimen} disabled></input>
                                        </div>
                                    </div>
                                </div>
                                <br></br>
                                <br></br>
                                <div className="row">
                                    <div className="col">
                                        <div>
                                            <label>Dirección Constancia Situación Fiscal</label>
                                            <br></br>
                                            <input type="input" name="DireccionFiscal" id="DireccionFiscal" className="form-control Input-Style" value={data.DireccionFiscal} disabled></input>
                                            <label></label>
                                        </div>
                                    </div>
                                </div>
                                <br></br>
                                <br></br>
                                <div className="row">
                                    <div className="col-lg-6">
                                        <div>
                                            <label className='Text-Red'>*</label><label>Tipo Proveedor</label>
                                            <br></br>
                                            <select name="TipoProveedor" id="TipoProveedor" aria-label="Default select example" className="form-select Select-Style" required>
                                                {
                                                    data.TipoProveedor == ""
                                                    ?
                                                    <option value="">Selecciona...</option>
                                                    :
                                                    proveedor.map(item => (
                                                        item.Codigo == data.TipoProveedor
                                                        &&
                                                        <option value={item.Codigo}>{item.Nombre}</option>       
                                                    ))
                                                }
                                                {
                                                    proveedor.map(item => (
                                                        item.Codigo != data.TipoProveedor
                                                        &&
                                                        <option value={item.Codigo}>{item.Nombre}</option> 
                                                    ))
                                                } 
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-lg-6">
                                        <div>
                                            <label className='Text-Red'></label><label>Registro REPSE</label>
                                            <br></br>
                                            <input type="input" name="RegistroREPSE" id="RegistroREPSE" className="form-control Input-Style" ></input>
                                            <label></label>
                                        </div>
                                    </div>
                                    <div className="col-lg-6">
                                        <div>
                                            <label className='Text-Red'>*</label><label>Categoria de Abasto y Suministro</label>
                                            <br></br>
                                            <select name="CategoriaAbastoSuministro" id="CategoriaAbastoSuministro" aria-label="Default select example" className="form-select Select-Style" required>
                                                {
                                                    data.CategoriaAbastoSuministro == ""
                                                    ?
                                                    <option value="">Selecciona...</option>
                                                    :
                                                    categoriaAbastoSuministro.map(item => (
                                                        item.Codigo == data.CategoriaAbastoSuministro
                                                        &&
                                                        <option value={item.Codigo}>{item.Nombre}</option>       
                                                    ))
                                                }
                                                {
                                                    categoriaAbastoSuministro.map(item => (
                                                        item.Codigo != data.CategoriaAbastoSuministro
                                                        &&
                                                        <option value={item.Codigo}>{item.Nombre}</option>
                                                    ))
                                                } 
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-lg-6">
                                        <div>
                                            <label className='Text-Red'>*</label><label>Sub Categoría de Abasto y Suministro</label>
                                            <br></br>
                                            <select name="SubcategoriaAbastoSuministro" id="SubcategoriaAbastoSuministro" aria-label="Default select example" className="form-select Select-Style" required>
                                                {
                                                    data.SubcategoriaAbastoSuministro == ""
                                                    ?
                                                    <option value="">Selecciona...</option>
                                                    :
                                                    subcategoriaAbastoSuministro.map(item => (
                                                        item.Codigo == data.SubcategoriaAbastoSuministro
                                                        &&
                                                        <option value={item.Codigo}>{item.Nombre}</option>       
                                                    ))
                                                }
                                                {
                                                    subcategoriaAbastoSuministro.map(item => (
                                                        item.Codigo != data.SubcategoriaAbastoSuministro
                                                        &&
                                                        <option value={item.Codigo}>{item.Nombre}</option>
                                                    ))
                                                } 
                                            </select>
                                        </div>
                                    </div>
                                    <br></br>
                                    <br></br>
                                </div>
                                <br></br>
                                <br></br>
                                <i id="Chg"className="fa fa-spinner fa-spin Chg"></i>
                                <input id='Btn' type='submit' value='Continuar' className='Button-Style'></input>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ProviderGeneralData;